/* eslint-disable complexity */
import React, { useState, useEffect, useCallback, useContext } from 'react';
import _get from 'lodash/get';
import {
  Container,
  Checkbox,
  FormControlLabel,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CheckFilledIcon from '@material-ui/icons/CheckCircleRounded';
import PendingIcon from '@material-ui/icons/WatchLaterRounded';
import CanceledIcon from '@material-ui/icons/RemoveCircleRounded';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import {
  UserContext,
  UserDispatchContext
} from '../../../../Contexts/UserContext';
import {
  ContractsContext,
  ContractsRefreshContext
} from '../../../../Contexts/ContractsContext';
import { AlertsDispatchContext } from '../../../../Contexts/AlertsContext';
import {
  GoogleClientContext,
  GoogleClientDispatchContext
} from '../../../../Contexts/GoogleClientContext';

import { history } from '../../../../Routes/history';
import Title from '../../../../Components/Labels/Title';
import TransactionCard from '../../../../Components/Cards/TransactionCard/TransactionCard';
import TransactionErrors from '../TransactionErrors';
import TransactionActions from '../TransactionAction/TransactionActions';
import { TransactionStatusAPI } from '../../../../API/Payments/TransactionStatusAPI';
import { UpdateContract } from '../../../../API/Contracts/ContractsAPI';
import { GoogleSignUpAPI } from '../../../../API/UserAPI';
import { GoogleLoginAPI } from '../../../../API/SocialUserAPI';
import FullSizeProgress from '../../../../Components/Progress/FullSize/FullSizeProgress';
import {
  TRANSACTION_STATUS,
  TRANSACTION_TYPES,
  LinkToDonationPDF,
  PAYMENT_METHOD
} from '../../payment_enums';
import Stepper from '../../../../Components/Stepper/Stepper';
import FooterPayment from '../../FooterPayment';
import SweetAlert from '../../../../Components/Alerts/SweetAlert';
import CallToActionDialog from '../../../../Components/Dialogs/CallToActionDialog';
import RegisterIcon from '../../../../Components/CustomIcons/RegisterIcon';
import ContractAssociationIcon from '../../../../Components/CustomIcons/ContractAssociateIcon';
import ConfirmationDialog from '../../../../Components/Dialogs/ConfirmationDialog';
import TransactionModalFooter from './TransactionModalFooter';
import LoginDialog from '../../../Login/LoginDialog';

import { extractErrorMessage } from '../../../../Utils/Errors/Errors';
import {
  TERMS,
  TERMS_ROUTES
} from '../../../Information/Information/Information';
import { ROUTE_NAMES } from '../../../../Routes/Routes';
import { PrivacyPoliciesLink } from '../../../../Configs/Links';
import { Company } from '../../../../Configs/general';
import { ALERT_TYPE } from '../../../../Components/Alerts/alert_enums';
import ActivateDigitalInvoiceBannerIcon from '../../../../Components/CustomIcons/DigitalInvoiceIcon';
import { INVOICE_CONTRACTS } from '../../../Contracts/contract_enums';
import { updateUser } from '../../../../Utils/User/Actions';
import CallToAssociationConfirmActionDialog from '../../../../Components/Dialogs/CallToAssociationConfirmActionDialog';
import CallToDigitalInvoiceConfirmActionDialog from '../../../../Components/Dialogs/CallToDigitalInvoiceConfirmActionDialog';

const TRANSACTION_REFRESH_TIMEOUT = 15000;

const TransactionGDC = props => {
  const { transactionId } = props.match.params;
  const {
    state = { from: null, price: null, insuranceRequestId: null }
  } = props.location;

  const { price, insuranceRequestId } = state;

  // * CONTEXTS
  const currentUser = useContext(UserContext);
  const contracts = useContext(ContractsContext);
  const setAlert = useContext(AlertsDispatchContext);
  const setCurrentUser = useContext(UserDispatchContext);
  const googleData = useContext(GoogleClientContext);
  const setGoogleData = useContext(GoogleClientDispatchContext);
  const refreshContracts = useContext(ContractsRefreshContext);

  const authToken = _get(currentUser, 'token');

  // * STATE HOOKS;
  const [loading, setLoading] = useState(true);
  const [digitalInvoiceLoading, setDigitalInvoiceLoading] = useState(false);
  const [terms, setTerms] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [transaction, setTransaction] = useState(null);
  const [timer, setTimer] = useState(null);
  const [registerDialogOpen, setRegisterDialogOpen] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [newUserParams, setNewUserParams] = useState({});
  const [associationSuggestionOpen, setAssociationSuggestionOpen] = useState(
    false
  );
  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [associationDialogOpen, setAssociationDialogOpen] = useState(false);
  const [
    activateDigitalInvoiceDialogOpen,
    setActivateDigitalInvoiceDialogOpen
  ] = useState(false);
  const [cancelAssociation, setCancelAssociation] = useState(false);
  const [cancelDigitalInvoice, setCancelDigitalInvoice] = useState(false);
  const [digitalInvoiceDismissed, setDigitalInvoiceDismissed] = useState(false);
  const [associationDismissed, setAssociationDismissed] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('/');
  const [nextButtonText, setNextButtonText] = useState('Finalizar');

  // * OTHER HOOKS
  const classes = useStyles();

  // * STEPS
  const steps = [
    {
      label: 'Referencia de pago'
    },
    {
      label: 'Método de pago'
    },
    {
      label: 'Transacción',
      action:
        state && state.from && state.from.includes(ROUTE_NAMES.transactions)
          ? {
              text: 'Volver',
              onCall: () => history.go(-1)
            }
          : { text: nextButtonText, onCall: () => history.push(redirectUrl) }
    }
  ];

  const donationSteps = [
    {
      label: 'Comparto mi energía'
    },
    {
      label: 'Detalle de pago'
    },
    {
      label: 'Transacción',
      action:
        state && state.from === ROUTE_NAMES.transactions
          ? { text: 'Volver', onCall: () => history.push(state.from) }
          : { text: 'Finalizar', onCall: () => history.push('/') }
    }
  ];

  // * FUNCTIONS
  const onCancelAssociation = useCallback(() => {
    setCancelAssociation(true);
    setAssociationSuggestionOpen(false);
    setAssociationDismissed(true);
  }, []);

  const onCancelDigitalInvoice = useCallback(() => {
    setDigitalInvoiceDismissed(true);
    setCancelDigitalInvoice(true);
    setActivateDigitalInvoiceDialogOpen(false);
  }, []);

  const onAcceptAssociationContract = useCallback(contractId => {
    history.push(ROUTE_NAMES.associate, {
      contractId
    });
  }, []);

  const isAssociated = useCallback(
    contractId => {
      return contracts.some(c => c.id === contractId);
    },
    [contracts]
  );

  const onChangeTerms = useCallback(() => {
    setTerms(!terms);
  }, [terms]);

  const fetchTransaction = useCallback(async () => {
    setLoading(true);
    const response = await TransactionStatusAPI(transactionId);
    setLoading(false);
    if (response.success) {
      const transactionData = response.data.data;
      setTransaction(transactionData);

      if (!authToken && transactionData) {
        setRegisterDialogOpen(true);
      } else {
        setRegisterDialogOpen(false);
      }

      if (
        authToken &&
        transactionData &&
        transactionData.contractId &&
        !isAssociated(transactionData.contractId) &&
        !associationDismissed &&
        transactionData.type !== TRANSACTION_TYPES.MeterRecharge
      ) {
        setAssociationSuggestionOpen(true);
      } else {
        setAssociationSuggestionOpen(false);
        setAssociationDialogOpen(false);
      }

      if (
        transactionData &&
        transactionData.type === TRANSACTION_TYPES.MeterRecharge &&
        transactionData.status === TRANSACTION_STATUS.Approved
      ) {
        setNextButtonText('Continuar');
        setRedirectUrl(
          `${ROUTE_NAMES.prepaidMeter}/${transactionData.requestId}`
        );
      }
    } else {
      history.replace('/');
    }
  }, [transactionId, authToken, isAssociated, associationDismissed]);

  const handleGoogleLogin = useCallback(
    async data => {
      const { email, givenName, familyName, encodedToken } = data;

      setGoogleLoading(true);

      const authResponse = await GoogleLoginAPI(encodedToken);

      if (!authResponse.success) {
        setAlert({
          type: ALERT_TYPE.ERROR,
          message: extractErrorMessage(authResponse).message
        });
        setGoogleData(null);
        setGoogleLoading(false);
        return;
      }

      const responseData = authResponse.data.data;
      const userType = responseData.userType;

      if (userType === 'new') {
        const params = {
          firstName: givenName.trim(),
          lastName: familyName.trim(),
          email: email.trim(),
          idToken: encodedToken,
          contractId: transaction ? transaction.contractId : null
        };

        setConfirmationDialog(true);
        setNewUserParams({ google: params });
        setGoogleData(null);
        return;
      }

      const { token, appToken } = responseData;

      if (userType === 'google') {
        setGoogleData(null);
        updateUser(setCurrentUser, token, appToken);
      }
    },
    [setAlert, setCurrentUser, setGoogleData, transaction]
  );

  const handleTermsDialog = useCallback(
    async closed => {
      if (closed) {
        setAlert({
          type: ALERT_TYPE.INFO,
          message:
            'Se ha cerrado la ventana de términos y condiciones. Intenta nuevamente'
        });
        setLoading(false);
        setTerms(false);
        return;
      }

      let signUpResponse;

      if (newUserParams.google) {
        signUpResponse = await GoogleSignUpAPI(newUserParams.google);
      }

      if (!signUpResponse.success) {
        setAlert({
          type: ALERT_TYPE.ERROR,
          message: extractErrorMessage(signUpResponse).message
        });
        setLoading(false);
        return;
      }

      const { token, appToken } = signUpResponse.data.data;

      updateUser(setCurrentUser, token, appToken);

      return { unmounting: true, closeDialog: false };
    },
    [newUserParams, setAlert, setCurrentUser]
  );

  const goUserAuth = useCallback(() => {
    if (transaction.registeredUser) {
      setOpenLoginDialog(true);
      return;
    }

    history.push(`/completar-registro/${transactionId}`);
  }, [transaction, transactionId]);

  const activateDigitalInvoiceHandler = useCallback(
    async contractId => {
      setActivateDigitalInvoiceDialogOpen(false);

      const editedAssociation = {
        digitalInvoice: true,
        sendInvoice: true,
        sendEmailInvoice: true,
        origin: {
          url: window.location.pathname
        }
      };

      setDigitalInvoiceLoading(true);
      const response = await UpdateContract(
        authToken,
        contractId,
        editedAssociation
      );

      setDigitalInvoiceLoading(false);

      if (!response.success) {
        setAlert({
          type: ALERT_TYPE.ERROR,
          message: extractErrorMessage(response).message
        });
        return;
      }

      refreshContracts();

      setAlert({
        type: ALERT_TYPE.SUCCESS,
        message: 'Gracias por activar tu factura digital'
      });
    },
    [authToken, setAlert, refreshContracts]
  );

  useEffect(() => {
    setDigitalInvoiceDismissed(false);
    setAssociationDismissed(false);
    setCancelDigitalInvoice(false);
  }, [transaction && transaction.contractId]);

  useEffect(() => {
    if (googleData) {
      handleGoogleLogin(googleData);
    }
  }, [googleData, handleGoogleLogin]);

  useEffect(() => {
    fetchTransaction();
  }, [transactionId, fetchTransaction]);

  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timer]);

  useEffect(() => {
    if (!transaction) {
      return;
    }

    if (transaction.status !== TRANSACTION_STATUS.Pending) {
      return;
    }

    const timeout = setTimeout(() => {
      fetchTransaction();
    }, TRANSACTION_REFRESH_TIMEOUT);

    setTimer(timeout);
  }, [transaction, fetchTransaction]);

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    if (!(transaction && transaction.contractId)) {
      return;
    }

    if (digitalInvoiceDismissed) {
      return;
    }

    const transactionContract = contracts.find(
      c => c.id === transaction.contractId
    );

    if (!transactionContract) {
      return;
    }

    const allowedContractType = INVOICE_CONTRACTS.includes(
      transactionContract.type
    );

    if (!allowedContractType) {
      return;
    }

    if (transactionContract.digitalInvoice) {
      return;
    }

    setActivateDigitalInvoiceDialogOpen(true);
  }, [contracts, currentUser, transaction]);

  // * FUNCTIONS
  const renderStatus = () => {
    if (transaction.status === TRANSACTION_STATUS.Pending) {
      return (
        <>
          <PendingIcon
            className={`${classes.iconBase} ${classes.iconWarning}`}
          />
          <Title text="Transacción pendiente" />
          <Typography className={classes.helpText}>
            Esta página se actualizará automáticamente
          </Typography>
        </>
      );
    }

    if (transaction.status === TRANSACTION_STATUS.Approved) {
      return (
        <>
          <CheckFilledIcon
            className={`${classes.iconBase} ${classes.iconSuccess}`}
          />
          <Title text="Transacción exitosa" />
        </>
      );
    }

    if (transaction.status === TRANSACTION_STATUS.Rejected) {
      return (
        <>
          <CanceledIcon
            className={`${classes.iconBase} ${classes.iconError}`}
          />
          <Title text="Transacción rechazada" />
        </>
      );
    }

    if (transaction.status === TRANSACTION_STATUS.Failed) {
      return (
        <>
          <CanceledIcon
            className={`${classes.iconBase} ${classes.iconError}`}
          />
          <Title text={'Transacción fallida'} />
        </>
      );
    }
  };

  return (
    <>
      <div className={classes.root}>
        {transaction && (
          <Container maxWidth="md" className={classes.stepperContainer}>
            <Stepper
              steps={
                transaction.type === TRANSACTION_TYPES.DonationCOVID19
                  ? donationSteps
                  : steps
              }
              currentStep={2}
            />
          </Container>
        )}
        {transaction && (
          <Container
            maxWidth="md"
            className={classes.innerRoot}
            id="transaction_to_download"
          >
            <>
              <div className={classes.titleContainer}>{renderStatus()}</div>
              {transaction.status === TRANSACTION_STATUS.Approved &&
                transaction.donationValue > 0 && (
                  <SweetAlert
                    id="Transaction_div_donation_success"
                    type="success"
                    noIcon
                    classes={{
                      root: classes.donationAlert
                    }}
                    message={
                      <>
                        <Typography className={classes.donationMessage}>
                          <span className={classes.donationTitle}>
                            ¡Gracias!
                          </span>{' '}
                          Con tu aporte voluntario “Comparto mi energía”,
                          usuarios de los servicios de energía y gas natural,
                          recibirán alivios para el pago de sus facturas, según
                          lo establecido en el{' '}
                          <span
                            className={classes.donationLink}
                            onClick={LinkToDonationPDF}
                          >
                            Decreto 517 de 2020
                          </span>{' '}
                          del Ministerio de Minas y Energía.
                        </Typography>
                      </>
                    }
                    onClick={() => null}
                  />
                )}
              <TransactionCard
                transaction={transaction}
                insuranceRequestId={insuranceRequestId}
                insurancePrice={price}
              />
              {transaction.status === TRANSACTION_STATUS.Pending && (
                <>
                  {transaction.paymentMethod === PAYMENT_METHOD.BREB && (
                    <SweetAlert
                      id="AuthHome_div_isBrebPaymentMethodPending_info"
                      classes={{ root: classes.brebSweetAlert }}
                      type="warning"
                      message={
                        <>
                          Recuerda finalizar el proceso de pago con Bre-B desde
                          la aplicación del banco para completar tu transacción.
                        </>
                      }
                    />
                  )}
                  <Typography className={classes.helpText}>
                    Si el estado no se actualiza y observas un descuento en tu
                    cuenta, puedes contactarnos en alguna de nuestras líneas de
                    atención:{' '}
                    {(Company.attentionLine[0].number || []).map(
                      ({ text, phone }, index) => (
                        <span key={index}>
                          {text} ({phone})
                          {index < Company.attentionLine[0].number.length - 1
                            ? ', '
                            : ''}
                        </span>
                      )
                    )}
                    .
                  </Typography>
                </>
              )}
              <TransactionActions
                transaction={transaction}
                transactionId={transactionId}
              />
              {transaction.status !== TRANSACTION_STATUS.Approved && (
                <TransactionErrors transaction={transaction} />
              )}
            </>
          </Container>
        )}
        <FooterPayment currentStep={steps[2]} disabledNext={false} />
      </div>

      {confirmationDialog && (
        <ConfirmationDialog
          open={confirmationDialog}
          title="Términos y condiciones"
          content={
            <FormControlLabel
              control={
                <Checkbox
                  id="Login_dialog_terms"
                  checked={terms}
                  onClick={onChangeTerms}
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  disabled={Boolean(currentUser)}
                  value="checkedI"
                />
              }
              label={
                <Typography className={classes.termsText}>
                  He leído y acepto los{' '}
                  <a
                    className={classes.link}
                    href={`${ROUTE_NAMES.information}/${
                      TERMS_ROUTES[TERMS.introduction]
                    }`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    términos y condiciones
                  </a>{' '}
                  de uso, la{' '}
                  <a href={PrivacyPoliciesLink}>
                    política y aviso de privacidad
                  </a>{' '}
                  y autorizo el tratamiento de mis datos personales.
                </Typography>
              }
            />
          }
          cancelButtonText="Cancelar"
          submitButtonText="Continuar"
          disabled={!terms}
          setDialog={setConfirmationDialog}
          requestCallback={handleTermsDialog}
        />
      )}

      {registerDialogOpen && (
        <CallToActionDialog
          open={registerDialogOpen}
          icon={RegisterIcon}
          title={<>¡Tu tiempo es importante!</>}
          message={
            <>
              Regístrate en nuestro portal y
              <br />
              olvídate de repetir tus datos.
              <br />
              <br />
            </>
          }
          handleClose={() => {
            setRegisterDialogOpen(false);
          }}
          footer={
            <TransactionModalFooter
              onClick={goUserAuth}
              loading={googleLoading}
            />
          }
        />
      )}

      {openLoginDialog && (
        <LoginDialog
          open={openLoginDialog}
          setOpen={setOpenLoginDialog}
          hideSocialButtons={true}
        />
      )}

      {currentUser && activateDigitalInvoiceDialogOpen && transaction && (
        <CallToActionDialog
          open={activateDigitalInvoiceDialogOpen}
          icon={ActivateDigitalInvoiceBannerIcon}
          title="¡Activa tu factura digital!"
          message={
            <span className={classes.modalDescription}>
              Activa tu factura digital y recíbela por <br />
              WhatsApp, SMS y/o correo electrónico.
              <br />
              <br />
            </span>
          }
          confirmButtonText="Activar factura digital"
          handleConfirmClick={() =>
            activateDigitalInvoiceHandler(transaction.contractId)
          }
          dismissButtonText="Ahora no"
          handleDismissClick={() => onCancelDigitalInvoice()}
          handleClose={() => onCancelDigitalInvoice()}
        />
      )}

      <CallToActionDialog
        open={associationSuggestionOpen}
        icon={ContractAssociationIcon}
        title={'¡Todo en un solo clic!'}
        message={
          <>
            Asocia {Company.contractConjugation.regular.singular.demonstrative}{' '}
            y disfruta de <br /> todos los beneficios del portal.
            <br />
            <br />
          </>
        }
        confirmButtonText={`Asociar ${Company.contractConjugation.regular.singular.main}`}
        dismissButtonText="Ahora no"
        handleConfirmClick={() =>
          onAcceptAssociationContract(transaction.contractId)
        }
        handleDismissClick={() => onCancelAssociation()}
        handleClose={() => {
          onCancelAssociation();
        }}
      />

      {transaction && (
        <CallToAssociationConfirmActionDialog
          open={cancelAssociation}
          onAccept={() => onAcceptAssociationContract(transaction.contractId)}
          onDeny={() => {
            setCancelAssociation(false);
            setAssociationDismissed(true);
          }}
          acceptText={`Asociar ${Company.contractConjugation.regular.singular.main}`}
          denyText={'No asociar'}
          title={'¿Estás seguro?'}
        />
      )}

      {transaction && (
        <CallToDigitalInvoiceConfirmActionDialog
          open={cancelDigitalInvoice}
          onAccept={() => {
            activateDigitalInvoiceHandler(transaction.contractId);
          }}
          onDeny={() => {
            setCancelDigitalInvoice(false);
            setDigitalInvoiceDismissed(true);
          }}
          acceptText={'Activar factura digital'}
          denyText={'No activar'}
          title={'¿Estás seguro?'}
        />
      )}

      {(loading || digitalInvoiceLoading) &&
        !registerDialogOpen &&
        !associationSuggestionOpen &&
        !associationDialogOpen &&
        !activateDigitalInvoiceDialogOpen && <FullSizeProgress />}
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    marginBottom: theme.custom.footerHeight.stepper
  },
  innerRoot: {
    justifyContent: 'space-around',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    marginBottom: theme.spacing(11),
    // * Responsive
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(),
      marginBottom: theme.spacing()
    }
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  iconBase: {
    fontSize: 24,
    marginRight: theme.spacing()
  },
  iconSuccess: {
    color: theme.palette.success.main
  },
  iconError: {
    color: theme.palette.error.main
  },
  iconWarning: {
    color: theme.palette.warning.main
  },
  stepperContainer: {
    // * Mobile
    [theme.breakpoints.up('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2)
    },
    [theme.breakpoints.up('xm')]: {
      paddingLeft: 0,
      paddingRight: 0,
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5)
    },
    // * Web
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing()
    }
  },
  helpText: {
    fontSize: 11,
    marginLeft: 10,
    marginTop: 4
  },
  donationAlert: {
    marginBottom: theme.spacing(2)
  },
  donationTitle: {
    fontWeight: 600,
    fontSize: 14
  },
  donationMessage: {
    fontWeight: 500,
    fontSize: 14,
    textAlign: 'justify'
  },
  donationLink: {
    fontWeight: 500,
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.primary.main
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 14
    }
  },
  modalDescription: {
    fontSize: 12
  },
  brebSweetAlert: {
    margin: '0 0 8px'
  }
}));

export default TransactionGDC;
